// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sub-admin department/designation dialogs. */

.subadmin-form__body {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}

.subadmin-form__field {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
}

.subadmin-form__field > label {
  font-weight: 500;
  color: var(--ds-text);
}
`, "",{"version":3,"sources":["webpack://./src/subadmins/components/SubadminForms.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/* Sub-admin department/designation dialogs. */\n\n.subadmin-form__body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n}\n\n.subadmin-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n}\n\n.subadmin-form__field > label {\n  font-weight: 500;\n  color: var(--ds-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
